import { el, setAttr } from 'redom';

class TextInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-text-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = el('input', {
      type: 'text',
      disabled: true
    });

    return this.input;

  }

  update(options) {

    setAttr(this.input, {
      placeholder: options.placeholder || ''
    });

  }

}

export default TextInputRenderer;